<template>
  <div
    v-loading.fullscreen.lock="fullscreenLoading"
    class="reassignment-view">
    <div class="content">
      <h1>Reasignar clientes</h1>
      <el-form
        ref="form"
        :model="model"
        :rules="rules"
        @submit.native.prevent="onSubmit">
        <div class="data">
          <div style="margin-right: 30px;">
            <el-form-item
              label="Vendedor"
              prop="fromSellerId">
              <el-select
                v-model="model.fromSellerId"
                style="width: 350px"
                placeholder="Selecciona un vendedor">
                <el-option
                  v-for="item in users"
                  :key="item.id"
                  :label="item.firstName + ' ' + item.lastName"
                  :value="item.id"/>
              </el-select>
            </el-form-item>
          </div>
          <div style="margin-right: 30px;">
            <p>reasignar a:</p>
          </div>
          <div style="margin-right: 30px;">
            <el-form-item
              label="Vendedor"
              prop="toSellerId">
              <el-select
                v-model="model.toSellerId"
                style="width: 350px"
                placeholder="Selecciona un vendedor">
                <el-option
                  v-for="item in users"
                  :key="item.id"
                  :label="item.firstName + ' ' + item.lastName"
                  :value="item.id"/>
              </el-select>
            </el-form-item>
          </div>
          <div style="align-self: flex-end">
            <el-form-item>
              <el-button
                type="primary"
                native-type="submmit">Reasignar</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
/**
*
* ReassignmentView Component
*
* @author Emmanuel Hernández
* @copyright 2019, Marciano Studio S.C.
*/
import http from '@/services/http.service'

export default {
  name: 'ReassignmentView',
  data () {
    return {
      fullscreenLoading: false,
      model: {
        fromSellerId: '',
        toSellerId: ''
      },
      rules: {
        fromSellerId: [
          {required: true, message: 'El campo es requerido'}
        ],
        toSellerId: [
          {required: true, message: 'El campo es requerido'}
        ]
      }
    }
  },
  computed: {
    users () {
      return this.$store.getters['users/items']
    }
  },
  methods: {
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$confirm('Los cambios no son reversibles. ¿Desea continuar?', '¿Está seguro de realizar estos cambios?', {
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            type: 'warning'
          }).then(() => {
            this.fullscreenLoading = true
            http.post(process.env.API_URL + 'reassignment/seller', this.model)
              .then(response => {
                this.$message.success('Clientes reasignados con éxito')
              })
              .catch(e => {
                this.$message.error('Hubo un error al ejecutar la acción')
              })
              .finally(() => {
                this.fullscreenLoading = false
              })
          }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
  .reassignment-view {
    padding: 30px;
    .content {
      background-color: #FFF;
      border: 1px solid #DDDDDD;
      border-radius: 3px;
      padding: 30px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.19);
      h1 {
        @include font-primary(21px, regular);
        color: #707070;
      }
      .data {
        display: flex;
        align-items: center;
      }
      p {
        @include font-primary(14px, regular);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/reassignment/reassignment.view.vue